import styled from 'styled-components';

const PaddingDiv = styled.div`
  padding-left: 8px;
  padding-right: 8px;
`;

export { PaddingDiv };
